import React from 'react';
import cx from 'classnames';
import styles from './menu.module.scss';

const Menu = React.forwardRef(({ listMode, children, onMouseLeave, simple, customStyles, className }, ref) => {
  if (simple) {
    return (
      <ul ref={ref} style={{ ...customStyles }} className={cx(styles.simpleMenu, className)} onMouseLeave={onMouseLeave}>
        {children}
      </ul>
    );
  }

  return (
    <ul
      ref={ref}
      style={{ ...customStyles }}
      className={cx(styles.menu, listMode ? styles.menuList : styles.menuCard, className)}
      onMouseLeave={onMouseLeave}
      onClick={e => e.stopPropagation()}
    >
      {children}
    </ul>
  );
});

export default Menu;
